import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column, MTableToolbar } from 'material-table';
import Button from '@material-ui/core/Button';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import {
    Tooltip,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField,
    DialogProps,
    Popover,
    Typography,
    FormControlLabel,
    withStyles
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import VisibilityIcon from '@material-ui/icons/Visibility';
import RedoIcon from '@material-ui/icons/Redo';
import { TatData } from 'src/reducers/fileUpload';
import { PreviewOrderData, RowDataManufactur } from 'src/reducers/manufactur';
import ThumbsUpDownRoundedIcon from '@material-ui/icons/ThumbsUpDownRounded';

import { RedesignReasons } from 'src/reducers/completeorderfile';
import { UserDetail } from 'src/reducers/user';
import { GetFileData } from 'src/reducers/rxForm';
import PlayCircleFilledTwoToneIcon from '@material-ui/icons/PlayCircleFilledTwoTone';

interface TableStateDate {
    columns: Array<Column<RowDataManufactur>>;
    data: RowDataManufactur[];
}

interface SubitReDesignCodes {
    producttype: string;
    category: string;
    reason: string;
}

export interface CFilterOrderViewProps {
    mfilteredOrderData: RowDataManufactur[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (filePath: string, fileName: string) => void;
    onBulkDownload: (completedData: RowDataManufactur[] | RowDataManufactur) => void;
    onBulkDownloadStl: (completedData: RowDataManufactur[] | RowDataManufactur, filetype: string) => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;
    orderDataTat: TatData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;

    downloadFile: (filepath: string, filename: string, status: string) => void;

    caseFilter: (fcaseno: string, tcaseno: string, startDate: Date | null, endDate: Date | null, status: string) => void;
    caseFilterCust: (fcaseno: string, tcaseno: string) => void;

    userDetails: UserDetail;
    supportPage: (order: string) => void;

    getPreviewData: (orderno: string) => void;
    resetPreviewData: () => void;
    previewOrderData: PreviewOrderData;
    msgAtt: (msgAttachment: string) => void;
    goStlViewer: (data: GetFileData[]) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        reasonBox: {
            minWidth: '500px'
        },
        qcreq: {
            fontSize: '10px',
            textAlign: 'right',
            paddingRight: '24px',
            fontStyle: 'italic',
            color: 'red'
        },
        button: {
            margin: theme.spacing(1),
        },
        mtable: {
            '& .MuiButton-root': {
                fontSize: '12px',
                textTransform: 'capitalize'
            },
            '& .MuiIconButton-root': {
                padding: '0px 5px',
                borderRadius: '0%',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
        dialog: {
            margin: theme.spacing(2)
        },
        tabpanel: {
            margin: theme.spacing(2, 0),
            maxHeight: '260px',
            overflowY: 'auto'
        },
        fileHover: {
            cursor: 'pointer',
            color: '#3F51B5',
            '&:hover': {
                cursor: 'pointer',
                color: '#3F51B5'
            },
        },
        previewOrderfont: {
            fontSize: '12px',
            display: 'grid'
        },
        bubble: {
            display: 'inline-block',
        },
        bubbleReciver: {
            display: 'inline-block',
        },
        right: {
            textAlign: 'right',
            margin: '12px 12px'
        },
        left: {
            textAlign: 'left',
            margin: '12px 12px'
        },
        message: {
            fontWeight: 500
        },
        date: {
            fontSize: '12px'
        },
        imageHeight: {
            height: '50px'
        },
        mfrom: {
            fontWeight: 'bolder',
            color: '#4F93FE'
        },
        mto: {
            fontWeight: 'bolder',
            color: '#38C7D8'
        },
        textField: {
            margin: '0px !important'
        },
        chatBotWidth: {
            width: '50%'
        },
        attachment: {
            fontSize: '12px',
            cursor: 'pointer',
            '&:hover': {
                cursor: 'pointer',
                color: '#3F51B5'
            },
        },
        container: {
            bottom: 0,
            height: '240px',
            overflow: 'auto'
            // position: "fixed" // remove this so we can apply flex design
        },
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

const CFilterOrderView: React.StatelessComponent<CFilterOrderViewProps> = (props) => {
    const classes = useStyles({});

    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('sm');
    const [fullWidthReason] = React.useState(true);
    const [maxWidthReason] = React.useState<DialogProps['maxWidth']>('md');
    const [fullWidthFilter] = React.useState(true);
    const [maxWidthFilter] = React.useState<DialogProps['maxWidth']>('xs');
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const [tat, setTat] = React.useState('Next Day 7 AM');
    const [ptype, setPtype] = React.useState('');
    const [ptypeModel, setPtypeModel] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [categoryArray, setCategoryArray] = React.useState<string[]>([]);
    const [categoryModelArray, setCategoryModelArray] = React.useState<string[]>([]);
    const [categoryModel, setCategoryModel] = React.useState('');
    const [reason, setReason] = React.useState<SubitReDesignCodes[]>([]);
    const [reasonModel, setReasonModel] = React.useState<SubitReDesignCodes[]>([]);
    const [msg, setMsg] = React.useState('');
    const [msgApp, setMsgApp] = React.useState('');
    const [orderno, setOrderno] = React.useState('');
    const [userName, setuserName] = React.useState('');

    const popoverClick = (event: React.MouseEvent<HTMLButtonElement>, rowDataVal: RowDataManufactur) => {
        setOrderno(rowDataVal.orderno);
        setuserName(rowDataVal.labname);
        setAnchorEl(event.currentTarget);
    };

    const popoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [openRe, setOpenRe] = React.useState(false);
    const [openDesignReason, setOpenDesignReason] = React.useState(false);
    const [openModelReason, setOpenModelReason] = React.useState(false);

    const duplicateCateDesign = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(iddup => {
                return data.find(a => a.category === iddup && a.producttype !== 'Model');
            });
    };

    const duplicateCateModel = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(iddup => {
                return data.find(a => a.category === iddup && a.producttype === 'Model');
            });
    };

    const changeDesignCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategory(event.target.value);
            setOpenDesignReason(true);
        } else {
            setReason(reason.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryArray.indexOf(event.target.value);
            categoryArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryArray(categoryArray);
        }
    };
    const changeModelCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategoryModel(event.target.value);
            setOpenModelReason(true);
        } else {
            setReasonModel(reasonModel.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryModelArray.indexOf(event.target.value);
            categoryModelArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryModelArray(categoryModelArray);
        }
    };

    const changeDesignReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArray: SubitReDesignCodes = {
            producttype: 'Design',
            category: category,
            reason: event.target.value
        };
        reason.push(newArray);
        setReason(reason);
        categoryArray.push(category);
        setCategoryArray(categoryArray);
        setOpenDesignReason(false);
    };
    const changeModelReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArrayModel: SubitReDesignCodes = {
            producttype: 'Model',
            category: categoryModel,
            reason: event.target.value
        };
        reasonModel.push(newArrayModel);
        setReasonModel(reasonModel);
        categoryModelArray.push(categoryModel);
        setCategoryModelArray(categoryModelArray);
        setOpenModelReason(false);
    };

    const handleClickOpenRe = () => {
        setMsg('');
        setPtype('Design');
        setPtypeModel('Model');
        setCategory('0');
        setCategoryModel('0');
        setOrderno(orderno);
        setuserName(userName);
        setTat('Next Day 7 AM');
        setOpenRe(true);
        setReasonModel([]);
        setReason([]);
        setCategoryModelArray([]);
        setCategoryArray([]);
    };
    const handleCloseRe = () => {
        setOpenRe(false);
    };
    const onCloseDesignReason = () => {
        setOpenDesignReason(false);
    };
    const onCloseModelReason = () => {
        setOpenModelReason(false);
    };
    const handleSubmitRe = () => {
        const columns = {
            columns: {
                customer: userName,
                caseno: orderno,
                tat: tat,
                msg: msg.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            reasons: reason.concat(reasonModel),
            id: 'rword'
        };
        setOpenRe(false);
        props.redesignRequest(columns);
    };

    const [openCom, setOpenCom] = React.useState(false);
    const handleClickOpenCom = () => {
        setOpenCom(true);
    };
    const handleCloseCom = () => {
        setOpenCom(false);
    };
    const handleSubmitCom = () => {
        const columns = {
            columns: {
                customer: userName,
                caseno: orderno,
                status: '10'
            },
            id: 'asnds'
        };
        setOpenCom(false);
        setAnchorEl(null);

        props.redesignRequest(columns);
    };

    const [openAppro, setOpenAppro] = React.useState(false);
    const handleClickOpenApp = (ordernumber: string) => {
        setMsgApp('');
        setOrderno(ordernumber);
        setOpenAppro(true);
    };
    const handleCloseApp = () => {
        setOpenAppro(false);
    };
    const handleSubmitApp = () => {
        setOpenAppro(false);
        const array = [{
            orderno: orderno,
            approval_reqd: '1',
            remarks: msgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
        }];
        props.approvalRequired(array);
    };

    const msgAppChange = (msgValue: string) => {
        setMsgApp(msgValue);
    };

    const [dialogOpen, setdialogOpen] = React.useState(props.mfilteredOrderData.length > 0 ? false : true);
    const [fcaseno, setFcaseno] = React.useState('');
    const [tcaseno, setTcaseno] = React.useState('');
    const [countValidation, setcountValidation] = React.useState(false);

    const maxOrderCount = (fcase: string, tcase: string) => {
        if (Number(parseInt(fcase, 10)) && Number(parseInt(tcase, 10))) {
            const maxCount = Math.abs(parseInt(fcase, 10) - parseInt(tcase, 10));
            if (maxCount < 1000) {
                return false;
            }
        }
        return true;
    };

    const openFilter = () => {
        setcountValidation(false);
        setFcaseno('');
        setTcaseno('');
        setdialogOpen(true);
    };

    const changeFcaseno = (fcase: string) => {
        setFcaseno(fcase);
    };

    const changeTcaseno = (tcase: string) => {
        setcountValidation(false);
        setTcaseno(tcase);
    };

    const closeFilter = () => {
        setdialogOpen(false);
    };

    const submitFilter = () => {

        if (maxOrderCount(fcaseno, tcaseno)) {
            setcountValidation(true);
        } else {
            setcountValidation(false);
            props.caseFilterCust(fcaseno, tcaseno);
            setdialogOpen(false);
        }

    };

    const downloadFiletypes = ['STL', 'PTS', '3OX'];
    const [openDownload, setOpenDownload] = React.useState(false);
    const [fileTypes, setFileTypes] = React.useState<string[]>([]);
    const [rowDatastl, setRowData] = React.useState<RowDataManufactur[] | RowDataManufactur>([]);
    const [ziprstlDownload, setZiprstlDownload] = React.useState('0');

    const openDownloadDialog = (rowdata: RowDataManufactur[] | RowDataManufactur, ziprstl: string) => {
        if (Array.isArray(rowdata)) {
            setRowData(rowdata.filter((datarow) => (datarow.status === '14' || datarow.status === '10')));
        } else if (typeof (rowdata) === 'object' && (rowdata.status === '14' || rowdata.status === '10')) {
            setRowData(rowdata);
        }
        setFileTypes([]);
        setZiprstlDownload(ziprstl);
        setOpenDownload(true);
    };
    const closeDownloadDialog = () => {
        setOpenDownload(false);
        setRowData([]);
    };
    const filetypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            fileTypes.push(event.target.value);
            const tempType = fileTypes.filter((v, i) => fileTypes.indexOf(v) === i);
            setFileTypes(tempType);
        } else {
            setFileTypes(fileTypes.filter((allTypes) => allTypes !== event.target.value));
        }
    };
    const submitStlDownload = () => {
        setOpenDownload(false);
        if (ziprstlDownload === '1') {
            props.onBulkDownload(rowDatastl);
        } else {
            props.onBulkDownloadStl(rowDatastl, fileTypes.toString());
        }
        setRowData([]);
    };

    const [state] = React.useState<TableStateDate>({
        columns: [
            {
                title: 'Case No',
                field: 'orderno',
                filtering: false,
                render: rowData => (
                    <div>
                        {
                            rowData.qc_required === '0' ?
                                rowData.orderno
                                :
                                rowData.qc_required === '1' ?
                                    <div>
                                        {rowData.orderno}
                                        <div className={classes.qcreq}>
                                            QC Required
                                        </div>
                                    </div>
                                    :
                                    rowData.qc_required === '2' ?
                                        <div>
                                            {rowData.orderno}
                                            <div className={classes.qcreq} onClick={() => handleClickOpenApp(rowData.orderno)} style={{ color: 'green', cursor: 'pointer' }}>
                                                Approve
                                            </div>
                                        </div>
                                        :
                                        rowData.orderno
                        }
                    </div>
                ),
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'Customer Name',
                field: 'customername',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '13px'
                }
            },
            {
                title: 'Received on',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'Status',
                field: 'mfrstatus',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'Action',
                field: 'fdownload',
                export: false,
                // cellStyle: {
                //   backgroundColor: '#039be5',
                //   color: '#FFF'
                // },
                render: rowData => (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Tooltip title="Update" placement="top">
                            <IconButton
                                aria-label="view"
                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => popoverClick(event, rowData)}
                                disabled={rowData.status === '14' ? false : true}
                            >
                                <RedoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Support" placement="top">
                            <IconButton
                                aria-label="support"
                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => props.supportPage(rowData.orderno)}
                            >
                                <ThumbsUpDownRoundedIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View" placement="top">
                            <IconButton aria-label="view" onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {
                            rowData.vfiles !== '' ?
                                <Tooltip title="Video" placement="top">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.openVideoPlayerURL(rowData.vfiles.split(','), rowData.fpath)}
                                        aria-label="view video"
                                    >
                                        <PlayCircleFilledTwoToneIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                    </div>
                ),
                cellStyle: {
                    padding: '0px'
                }
            }
        ],
        data: props.mfilteredOrderData
    });

    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Filter" placement="top" arrow>
                            <Button
                                id="filterDate"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={openFilter}
                                className={classes.buttonSend}
                            >
                                <FilterListIcon />
                            </Button>
                        </Tooltip>
                        <Dialog
                            open={dialogOpen}
                            onClose={closeFilter}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="alert-dialog-title"><Typography variant="h6" style={{ textAlign: 'left', fontWeight: 'bold' }}>Case Filter: </Typography></DialogTitle>
                            <DialogContent dividers>
                                <Grid container justify="space-around" spacing={2}>
                                    <Grid item xs={12} sm={6} md={5}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            label="From Case no"
                                            value={fcaseno}
                                            onChange={(event) => changeFcaseno(event.target.value as string)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={5}>
                                        <TextField
                                            error={countValidation}
                                            helperText={countValidation && 'Total not more than 1000 case numbers'}
                                            fullWidth
                                            variant="outlined"
                                            label="To Case no"
                                            value={tcaseno}
                                            onChange={(event) => changeTcaseno(event.target.value as string)}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    type="button"
                                    color="primary"
                                    className={classes.HeadinG}
                                    onClick={submitFilter}
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={popoverClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    // startIcon={<DeleteIcon />}
                                    onClick={handleClickOpenCom}
                                >
                                    Complete
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className={classes.button}
                                    // endIcon={<RestoreIcon />}
                                    onClick={handleClickOpenRe}
                                >
                                    Re-Design
                                </Button>
                            </div>
                        </Popover>
                        {props.isDownloading === true ? <CircularProgress className={classes.buttonSend} /> : null}
                        <Dialog
                            open={openRe}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidthReason}
                            maxWidth={maxWidthReason}
                        >
                            <DialogTitle id="form-dialog-title">Re-Design Request on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <DialogContentText>
                                    Please select Reason, TAT and enter Remarks to submit.
                                </DialogContentText>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CssTextField
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtype(event.target.value as string)}
                                            value={ptype}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {
                                        duplicateCateDesign(props.redesignReasons).map((cate, indexRe1) => (
                                            typeof (cate) === 'object' && cate!.producttype !== 'Model' ?
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`category${indexRe1}`}
                                                                checked={categoryArray.indexOf(cate!.category) !== -1 ? true : false}
                                                                value={cate!.category}
                                                                onChange={changeDesignCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={cate!.category}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }

                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CssTextField
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtypeModel(event.target.value as string)}
                                            value={ptypeModel}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {
                                        duplicateCateModel(props.redesignReasons).map((cateModel, indexRe1) => (
                                            typeof (cateModel) === 'object' && cateModel!.producttype === 'Model' ?
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`categoryModel${indexRe1}`}
                                                                checked={categoryModelArray.indexOf(cateModel!.category) !== -1 ? true : false}
                                                                value={cateModel!.category}
                                                                onChange={changeModelCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={cateModel!.category}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }
                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={5}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-6"
                                                defaultValue="Next Day 7 AM"
                                                onChange={(event) => setTat(event.target.value as string)}
                                                value={tat}
                                            >
                                                {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                                    <MenuItem id={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => setMsg(event.target.value as string)}
                                                value={msg}
                                                required
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseRe} color="secondary">
                                    Cancel
                                </Button>
                                <Button
                                    size="small"
                                    disabled={(msg === '' || (reason.length === 0 && reasonModel.length === 0)) ? true : false}
                                    onClick={handleSubmitRe}
                                    color="primary"
                                >
                                    Re-Design
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDesignReason}
                            onClose={onCloseDesignReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{category} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-2"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeDesignReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsRe, indexRe1) => (
                                                            reasonsRe.producttype !== 'Model' && reasonsRe.category === category ?
                                                                <MenuItem id={reasonsRe.rowno} value={reasonsRe.code}>{reasonsRe.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openModelReason}
                            onClose={onCloseModelReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{categoryModel} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-5"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeModelReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason (Model)</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsModl, indexRe1) => (
                                                            reasonsModl.producttype === 'Model' && reasonsModl.category === categoryModel ?
                                                                <MenuItem id={reasonsModl.rowno} value={reasonsModl.code}>{reasonsModl.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openCom}
                            onClose={handleCloseCom}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Complete the Order : {orderno} ?</DialogTitle>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseCom} color="secondary">
                                    Cancel
                                </Button>
                                <Button size="small" onClick={handleSubmitCom} color="primary">
                                    Complete
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openAppro}
                            onClose={handleCloseApp}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Approve Design on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => msgAppChange(event.target.value as string)}
                                                value={msgApp}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseApp} color="secondary">
                                    Cancel
                                </Button>
                                <Button size="small" onClick={handleSubmitApp} color="primary">
                                    Approve
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDownload}
                            onClose={closeDownloadDialog}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidthFilter}
                            maxWidth={maxWidthFilter}
                        >
                            <DialogTitle id="form-dialog-title">Download files from {Array.isArray(rowDatastl) ? rowDatastl.length : 1} order(s) </DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    {
                                        ziprstlDownload === '0' && downloadFiletypes.map((typeFile, indexRe1) => (
                                            <Grid item xs={6} sm={4} md={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            id={`filetype${indexRe1}`}
                                                            checked={fileTypes.indexOf(typeFile) > -1}
                                                            value={typeFile}
                                                            onChange={filetypeChange}
                                                            name="Filetype"
                                                        />
                                                    }
                                                    label={typeFile}
                                                />
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={closeDownloadDialog} color="secondary">
                                    Cancel
                                </Button>
                                {ziprstlDownload === '0' && <Button size="small" onClick={submitStlDownload} disabled={fileTypes.length > 0 ? false : true} color="primary">
                                    Download
                                </Button>}
                                {ziprstlDownload === '1' && <Button size="small" onClick={submitStlDownload} color="primary">
                                    Download
                                </Button>}
                            </DialogActions>
                        </Dialog>
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        title="Order Search"
                        columns={state.columns}
                        data={props.mfilteredOrderData}
                        localization={{
                            toolbar: {
                                nRowsSelected: '',
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        components={{
                            Toolbar: some => (
                                <div className={classes.mtable}>
                                    <MTableToolbar {...some} />
                                </div>
                            )
                        }}
                        options={{
                            // filtering: true,
                            pageSize: 25,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '0px',
                                textAlign: 'center'
                            },
                            rowStyle: {
                                padding: '0px 0px'
                            },
                            selection: true,
                            selectionProps: (selecrowData: RowDataManufactur) => {
                                const checked = (selecrowData.status !== '14' && selecrowData.status !== '10') ? { checked: false } : {};
                                return {
                                    disabled: (selecrowData.status !== '14' && selecrowData.status !== '10'),
                                    ...checked
                                };
                            },
                            exportButton: true,
                            exportAllData: true,
                        }}
                        actions={[
                            {
                                icon: () => (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<CloudDownloadIcon />}
                                    >
                                        Download zip
                                    </Button>),
                                tooltip: 'Download zip files',
                                isFreeAction: false,
                                onClick: (event, rowData) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowData, '1');
                                    }
                                }
                            },
                            {
                                icon: () => (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<CloudDownloadIcon />}
                                    >
                                        Download STL/PTS/3OX
                                    </Button>),
                                tooltip: 'Download STL files/PTS/3OX',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, '0');
                                    }
                                }
                            }
                        ]}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default CFilterOrderView;



// WEBPACK FOOTER //
// ./src/components/layouts/CFilterOrderView.tsx